import { Col, Row, Space } from 'antd'
import PasswordRequestForm from 'app/components/Core/PasswordRequest/Form'
import { useNextUrl } from 'app/lib/hooks/useNextUrl'
import useTranslation from 'app/lib/hooks/useTranslation'
import LoginLink from 'app/pages/Authentication/Component/LoginLink'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const portalId = 'forgot-password-portal-id'

const SetPassword: React.FC<PageProps> = ({ route }) => {
  const { nextUrl } = useNextUrl()
  const navigate = useNavigate()
  const { tRoute } = useTranslation({ scope: route.key })

  const onSuccess = () => {
    navigate(`${Routes.Authentication.collection().email_confirmation}?next_url=${nextUrl}`, {
      replace: true
    })
  }

  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <p className="text-primary text-center">{tRoute({ id: 'description' })}</p>
      </Col>
      <Col span={24}>
        <PasswordRequestForm props={{ onSuccess, portalId, silentSuccess: true }} />
      </Col>
      <Col span={24}>
        <Row justify="end">
          <Col>
            <Space size={'large'} direction="vertical" align="center">
              <LoginLink />
              <Row justify="center">
                <Col>
                  <div id={portalId} />
                </Col>
              </Row>
            </Space>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default SetPassword
